import { render, staticRenderFns } from "./agentMoreRewardRecord.vue?vue&type=template&id=c949635a&"
import script from "./agentMoreRewardRecord.vue?vue&type=script&lang=js&"
export * from "./agentMoreRewardRecord.vue?vue&type=script&lang=js&"
import style0 from "./agentMoreRewardRecord.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports